import cssLonghand from"@team-griffin/css-longhand";import reduce from"lodash.reduce";var defineProperty=function(e,s,i){return s in e?Object.defineProperty(e,s,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[s]=i,e},_sidesMap,Side={A:"a",X:"x",Y:"y"},actualSides=["left","top","right","bottom"],sidesMap=(_sidesMap={},defineProperty(_sidesMap,Side.A,[0,1,2,3]),defineProperty(_sidesMap,Side.X,[0,2]),defineProperty(_sidesMap,Side.Y,[1,3]),_sidesMap),cssSides=function(e,s,i){return cssLonghand(e,reduce(sidesMap[s],function(e,s){return Object.assign({},e,defineProperty({},actualSides[s],i))},{}))};export default cssSides;export{Side};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@team-griffin/css-sides/dist/es/css-sides.production.js
// module id = 1386
// module chunks = 0